import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";

export interface IsLengthOptions {
  min?: number;
  max?: number;
  optional?: boolean;
}

export default function isLength(
  // tslint:disable-next-line:max-union-size
  value: string | number | undefined | null,
  options: IsLengthOptions,
  params?: IValidatorParams
): IValidationResult {
  if (options.optional && !value) {
    return {
      isValid: true,
    };
  }

  let isValid = true;
  const constraints: any = {};
  const valueLength = `${value}`.length;

  if (options.min && valueLength < options.min) {
    isValid = false;
    constraints.min = valueLength;
  }

  if (options.max && valueLength > options.max) {
    isValid = false;
    constraints.max = valueLength;
  }

  return {
    isValid,
    errors: {
      constraints,
      params: [(options?.min ?? 0).toString(), (options?.max ?? Infinity).toString()],
    },
  };
}
